<template>
  <canvas ref="canvas" class="w-full h-full"></canvas>
</template>
<script lang='ts'>
import { Vue, Component } from 'vue-property-decorator';
import { star } from './star'
@Component
export default class Star extends Vue {
  mounted() {
    star(this.$refs.canvas)
  }
}
</script>